import React from "react";
import styles from "./style/comp4.module.css";

export default function FlightCard({
  trainNumber = "",
  trainName = "12345, Rajdhani Express",
  trainType = "Train",
  from = {
    station: "Secunderabad Jn",
    code: "SC",
    time: "18:00",
    date: "11 May",
  },
  to = { station: "Agra Cantt", code: "AGC", time: "18:00", date: "12 May" },
  duration = "22hr 15min",
  halts = "23 halts",
  bookUrl = "",
  note = [
    "Book a ticket from KSR Bengaluru City Junction to Agra Cantt, as there are no seats available from Secunderabad.",
    "Tatkal booking opens at 10 AM for AC classes and 11 AM for non-AC classes, one day before the journey.",
  ],
  price = 0,
  trace_id,
  result_idx,
  is_lcc,
  baggage,
}) {
  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.trainName}>
          {trainNumber}, {trainName}
        </div>
        <div className={styles.trainType}>{trainType}</div>
      </div>
      <div className={styles.infoColumn}>
        <div className={styles.infoRow}>
          <div className={styles.stationBlock}>
            <div className={styles.stationName}>{from.station}</div>
            <div className={styles.stationCodeTime}>
              <span className={styles.stationCode}>{from.code}</span>
              <span className={styles.stationTime}>, {from.time}</span>
            </div>
            <div className={styles.stationDate}>{from.date}</div>
          </div>
          <div className={styles.middleBlock}>
            <div className={styles.duration}>{duration}</div>
            {/* <div className={styles.halts}>{halts}</div> */}
          </div>
          <div className={styles.stationBlock} style={{ textAlign: "right" }}>
            <div className={styles.stationName}>{to.station}</div>
            <div className={styles.stationCodeTime}>
              <span className={styles.stationCode}>{to.code}</span>
              <span className={styles.stationTime}>, {to.time}</span>
            </div>
            <div className={styles.stationDate}>{to.date}</div>
          </div>
        </div>

        {/* {info && info.length > 0 && (
                    <div className={styles.infoBlockGrid}>
                        {info.map((item, idx) => (
                            <div className={styles.infoBlockGridItem} key={idx}>
                                <div className={styles.infoCardGrid}>
                                    <div className={styles.infoTopLeft}>{item.class}</div>
                                    <div className={styles.infoTopRight}>({item.Quota})</div>
                                    <div className={styles.infoBottomLeft}>
                                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" style={{marginRight: 4, verticalAlign: "middle"}}>
                                            <rect x="3" y="5" width="14" height="8" rx="2" fill={getStatusColor(item.seats)}/>
                                            <rect x="6" y="8" width="2" height="2" rx="1" fill="white"/>
                                            <rect x="12" y="8" width="2" height="2" rx="1" fill="white"/>
                                        </svg>
                                        <span style={{ color: getStatusColor(item.seats) }}>
                                            {item.seats || "--"}
                                        </span>
                                    </div>
                                    <div className={styles.infoBottomRight}>
                                        ₹{item.price ? item.price.toLocaleString() : "--"}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )} */}

        {/* <div className={styles.bottomRow}>
          <div className={styles.flightPrice}>
            ₹{price ? price.toLocaleString() : "--"}
          </div>
        </div> */}
      </div>
      <ul className={styles.noteList}>
        {note.map((line, idx) => (
          <li key={idx} className={styles.noteListItem}>
            {line}
          </li>
        ))}
      </ul>
    </div>
  );
}
